export const getSlotKey = slot => {
  var _slot$slot;
  if (!(slot != null && (_slot$slot = slot.slot) != null && _slot$slot.startDate)) {
    return '';
  }
  return slot.slot.startDate;
};
export const formatTimeRange = _ref => {
  let {
    locale,
    endDate,
    startDate,
    timezone
  } = _ref;
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timezone
  };
  const startTime = new Intl.DateTimeFormat(locale, options).format(new Date(startDate));
  const endTime = new Intl.DateTimeFormat(locale, options).format(new Date(endDate));
  return `${startTime} - ${endTime}`;
};
export const getFormattedDateLabel = _ref2 => {
  var _selectedSlot$slot;
  let {
    selectedSlot,
    locale,
    timezone
  } = _ref2;
  if (!(selectedSlot != null && (_selectedSlot$slot = selectedSlot.slot) != null && _selectedSlot$slot.startDate)) {
    return '';
  }
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    timeZone: timezone
  }).format(new Date(selectedSlot.slot.startDate));
};
export const getSlotByKey = (key, availabilitySlots) => {
  return availabilitySlots.find(slot => getSlotKey(slot) === key);
};
//# sourceMappingURL=utils.js.map